"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _KPI = require("../KPI");

var _Typography = require("../../Typography");

var _KPITypes = require("../KPITypes");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var fontSizes = {
  large: {
    fontSize: "2.5rem",
    fontWeight: "bold"
  },
  small: {
    fontSize: "1.75rem",
    fontWeight: "bold"
  }
};
var outerWidths = {
  large: "12rem",
  small: "10rem"
};
var innerWidths = {
  large: "10rem",
  small: "8rem"
};
var variants = {
  large: "body2",
  small: "body3"
};
var marginYs = {
  large: 3,
  small: 2
};
var StyledBox = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "hasDividers";
  }
})(function (_ref) {
  var theme = _ref.theme,
      hasDividers = _ref.hasDividers;
  return {
    borderLeft: hasDividers ? "2px solid ".concat(theme.palette.brand.grey.pebble) : "initial",
    flexGrow: 1
  };
});
var StyledTypography = (0, _material.styled)(_Typography.Typography, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "size";
  }
})(function (_ref2) {
  var size = _ref2.size;
  return _objectSpread({}, fontSizes[size]);
});

var Node = function Node(_ref3) {
  var value = _ref3.value,
      brandColour = _ref3.brandColour,
      label = _ref3.label;

  var _useKPI = (0, _KPI.useKPI)(),
      size = _useKPI.size,
      hasDividers = _useKPI.hasDividers;

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBox, {
    alignItems: "center",
    display: "flex",
    hasDividers: hasDividers,
    justifyContent: "center",
    my: marginYs[size],
    width: outerWidths[size],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      width: innerWidths[size],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, {
        align: "center",
        size: size,
        sx: {
          color: _KPITypes.KPIColors[brandColour]
        },
        children: value
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        align: "center",
        color: "textSecondary",
        variant: variants[size],
        children: label
      })]
    })
  });
};

var _default = Node;
exports.default = _default;